let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3wI9H")).then(() => parcelRequire('jo350'));